(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["001"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    $('.custom-carousel-container').slick({
      slidesToShow: (screen.width >= 1200 ? 3 : 1),
      slidesToScroll: 1,
      autoplay: true,
      dots: true
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["centered-logo"] && !Shopify.designMode) return;
  try {
    
    /*document.addEventListener("DOMContentLoaded", function() {
        const logoContainer = document.querySelector(".centered-logo");
    
        window.addEventListener("scroll", function() {
            const scrollTop = window.scrollY;
            const windowHeight = window.innerHeight;
    
            if (scrollTop > windowHeight) {
                logoContainer.style.opacity = 1;
            } else {
                logoContainer.style.opacity = 0;
            }
        });
    });*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-slideshow"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    $('.custom-carousel-container').slick({
      slidesToShow: (screen.width >= 1200 ? 3 : 1),
      slidesToScroll: 1,
      autoplay: true,
      dots: true
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerTag = document.querySelector('header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.headerLogo = document.querySelector(".header__heading-logo-origin")
      this.headerStickyLogo = document.querySelector(".header__heading-logo-sticky")

      this.menuLogoOrigin = document.querySelector(".menu-logo-origin")
      this.menuLogoSticky = document.querySelector(".menu-logo-sticky")

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.headerTag.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
   
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.headerLogo?.classList.add("tw-hidden")
      this.menuLogoOrigin?.classList.add("!tw-hidden")
      this.headerStickyLogo?.classList.remove("tw-hidden")
      this.menuLogoSticky?.classList.remove("!tw-hidden")
      
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.headerLogo?.classList.remove("tw-hidden")
      this.menuLogoOrigin?.classList.remove("!tw-hidden")
      this.headerStickyLogo?.classList.add("tw-hidden")
      this.menuLogoSticky?.classList.add("!tw-hidden")
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-grid"] && !Shopify.designMode) return;
  try {
    
  var $masonry_grid = $('.masonry_grid').imagesLoaded(function() {
    $('.masonry_grid--item').each(function() {
      var width = $(this).width() / $(this).data("width");
      $(this).height($(this).data("height") * width);
      console.log("CD001 Orig.Width: ", $(this).data('width'), " Orig.height: ", $(this).data('height'), " Width: ", $(this).width(), " Height: ", $(this).height());
    });
    $masonry_grid.masonry({
      itemSelector: '.masonry_grid--item',
      columnWidth: '.masonry_grid--sizer',
      gutter: 0,
      percentPosition: true
    });
  });
  window.onresize = function() {
    $('.masonry_grid--item').each(function() {
      var width = $(this).width() / $(this).data("width");
      $(this).height($(this).data("height") * width);
      console.log("CD001 Orig.Width: ", $(this).data('width'), " Orig.height: ", $(this).data('height'), " Width: ", $(this).width(), " Height: ", $(this).height());
    });
    $masonry_grid.masonry({
      itemSelector: '.masonry_grid--item',
      columnWidth: '.masonry_grid--sizer',
      gutter: 0,
      percentPosition: true
    });
  }

  } catch(e) { console.error(e); }
})();
})();
